import { useQuery } from '@tanstack/react-query';

import { REACT_APP_API_FETCH_INTERVAL } from '#shared';

import { weatherApi } from '../aviationWeather.api';

export const useQueryTafs = () =>
  useQuery({
    queryKey: ['weather', 'tafs'],
    queryFn: weatherApi.getTafs,
    // select: transform,
    refetchInterval: 1000 * REACT_APP_API_FETCH_INTERVAL,
    refetchIntervalInBackground: true,
    placeholderData: previousData => previousData,
  });
